import { render, staticRenderFns } from "./Relationship.vue?vue&type=template&id=77edc726&scoped=true&"
import script from "./Relationship.vue?vue&type=script&lang=js&"
export * from "./Relationship.vue?vue&type=script&lang=js&"
import style0 from "./Relationship.vue?vue&type=style&index=0&id=77edc726&lang=scss&scoped=true&"
import style1 from "./Relationship.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77edc726",
  null
  
)

export default component.exports